export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14334.03f5638b.jpg";